document.addEventListener('DOMContentLoaded', function () {
  // Varias secciones incluyen este archivo: inicializar solo una vez para no duplicar los clics (p. ej. cantidad de 2 en 2).
  if (window.__mtScriptsIniciado) return;
  window.__mtScriptsIniciado = true;
  initReveal();
  initCountdown();
  initCantidad();
  initVariantes();
  initGaleria();
  initScrollComprar();
  initCarrusel();
  initEasysellColor();
  initPlanes();
  initFaq();
});

function initPlanes() {
  document.querySelectorAll('[data-dl-plan]').forEach(function (card) {
    card.addEventListener('click', function () {
      var group = card.closest('[data-dl-planes]');
      if (group) group.querySelectorAll('[data-dl-plan]').forEach(function (c) { c.classList.remove('dl-activo'); });
      card.classList.add('dl-activo');
      var qty = parseInt(card.getAttribute('data-dl-cantidad'), 10) || 1;
      var input = document.querySelector('[data-dl-cantidad-input]');
      if (input) { input.value = qty; input.dispatchEvent(new Event('change')); }
    });
  });
}

function initFaq() {
  document.querySelectorAll('.dl-faq-item').forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      var list = item.closest('.dl-faq-list');
      if (!list) return;
      list.querySelectorAll('.dl-faq-item').forEach(function (other) {
        if (other !== item) other.open = false;
      });
    });
  });
}

function initEasysellColor() {
  function paint(btn) {
    if (!btn) return;
    var cs = getComputedStyle(btn);
    var c1 = (cs.getPropertyValue('--mt-easysell-c1') || '#2fada6').trim() || '#2fada6';
    var c2 = (cs.getPropertyValue('--mt-easysell-c2') || '#1f8681').trim() || '#1f8681';
    var borderColor = (cs.getPropertyValue('--mt-easysell-border') || '#7fd8d2').trim() || '#7fd8d2';
    var gradient = 'linear-gradient(135deg, ' + c1 + ' 0%, ' + c2 + ' 100%)';
    if (btn.dataset.mtPintado === gradient) return;
    btn.style.setProperty('background', gradient, 'important');
    btn.style.setProperty('border-color', borderColor, 'important');
    btn.dataset.mtPintado = gradient;
  }

  document.querySelectorAll('.es-popup-button').forEach(paint);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type === 'childList') {
        m.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches && node.matches('.es-popup-button')) paint(node);
          node.querySelectorAll && node.querySelectorAll('.es-popup-button').forEach(paint);
        });
      } else if (m.type === 'attributes' && m.target instanceof HTMLElement && m.target.classList.contains('es-popup-button')) {
        paint(m.target);
      }
    });
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
}

function initCarrusel() {
  document.querySelectorAll('[data-mt-carrusel]').forEach(function (wrap) {
    var track = wrap.querySelector('.mt-carrusel-track');
    var prev = wrap.querySelector('[data-mt-carrusel-prev]');
    var next = wrap.querySelector('[data-mt-carrusel-next]');
    if (!track) return;
    function scrollByCard(dir) {
      var item = track.querySelector('.mt-carrusel-item');
      var amount = item ? item.getBoundingClientRect().width + 20 : 280;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }
    prev && prev.addEventListener('click', function () { scrollByCard(-1); });
    next && next.addEventListener('click', function () { scrollByCard(1); });
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initCountdown() {
  var boxes = document.querySelectorAll('[data-mt-countdown]');
  if (!boxes.length) return;
  boxes.forEach(function (box) {
    var hours = parseInt(box.getAttribute('data-mt-countdown'), 10) || 12;
    var key = 'mt-oferta-deadline';
    var deadline = parseInt(localStorage.getItem(key), 10);
    var now = Date.now();
    if (!deadline || isNaN(deadline) || deadline < now) {
      deadline = now + hours * 60 * 60 * 1000;
      try { localStorage.setItem(key, String(deadline)); } catch (e) {}
    }
    var hEl = box.querySelector('[data-mt-h]');
    var mEl = box.querySelector('[data-mt-m]');
    var sEl = box.querySelector('[data-mt-s]');
    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) {
        if (hEl) hEl.textContent = '00';
        if (mEl) mEl.textContent = '00';
        if (sEl) sEl.textContent = '00';
        clearInterval(timer);
        return;
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (hEl) hEl.textContent = String(h).padStart(2, '0');
      if (mEl) mEl.textContent = String(m).padStart(2, '0');
      if (sEl) sEl.textContent = String(s).padStart(2, '0');
    }
    tick();
    var timer = setInterval(tick, 1000);
  });
}

function initCantidad() {
  document.querySelectorAll('[data-mt-cantidad]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var menos = wrap.querySelector('[data-mt-menos]');
    var mas = wrap.querySelector('[data-mt-mas]');
    if (!input) return;
    menos && menos.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.dispatchEvent(new Event('change'));
    });
    mas && mas.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
      input.dispatchEvent(new Event('change'));
    });
  });
}

function initVariantes() {
  document.querySelectorAll('[data-mt-producto-form]').forEach(function (form) {
    var variantsData = form.querySelector('[data-mt-variantes-json]');
    if (!variantsData) return;
    var variants;
    try { variants = JSON.parse(variantsData.textContent); } catch (e) { return; }
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = form.querySelector('[data-mt-precio-actual]');
    var comparePriceEl = form.querySelector('[data-mt-precio-anterior]');
    var addBtn = form.querySelector('[data-mt-add-btn]');
    var optionButtons = form.querySelectorAll('[data-mt-opcion]');
    var selected = {};

    optionButtons.forEach(function (btn) {
      if (btn.classList.contains('mt-activo')) {
        selected[btn.getAttribute('data-mt-opcion')] = btn.getAttribute('data-mt-valor');
      }
    });

    function moneyFormat(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function findVariant() {
      return variants.find(function (v) {
        return Object.keys(selected).every(function (k) {
          return v.options[Number(k)] === selected[k];
        });
      });
    }

    function update() {
      var variant = findVariant();
      if (!variant) return;
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = moneyFormat(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = moneyFormat(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (addBtn) addBtn.disabled = !variant.available;
    }

    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.getAttribute('data-mt-opcion');
        form.querySelectorAll('[data-mt-opcion="' + group + '"]').forEach(function (b) {
          b.classList.remove('mt-activo');
        });
        btn.classList.add('mt-activo');
        selected[group] = btn.getAttribute('data-mt-valor');
        update();
      });
    });

    update();
  });
}

function initGaleria() {
  document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
    var main = galeria.querySelector('[data-mt-galeria-principal]');
    var thumbs = galeria.querySelectorAll('[data-mt-galeria-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-mt-full');
        var srcset = thumb.getAttribute('data-mt-full-srcset');
        var alt = thumb.getAttribute('data-mt-alt');
        if (main && src) {
          if (srcset) { main.setAttribute('srcset', srcset); } else { main.removeAttribute('srcset'); }
          main.src = src;
          if (alt) main.alt = alt;
        }
        thumbs.forEach(function (t) { t.classList.remove('mt-activo'); });
        thumb.classList.add('mt-activo');
        thumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      });
    });
  });
}

function initScrollComprar() {
  document.querySelectorAll('[data-mt-scroll-comprar]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = document.getElementById('mt-comprar');
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });
}
